import React, { useEffect, useState } from 'react';
import { useQRSession } from '../contexts/QRSessionContext';

const QRDisplay = ({ session, onNewSession }) => {
  const { 
    qrCode, 
    timeRemaining, 
    currentSequence, 
    stopSession,
    isActive,
    loading
  } = useQRSession();

  const [displayTime, setDisplayTime] = useState(timeRemaining);

  useEffect(() => {
    setDisplayTime(timeRemaining);
  }, [timeRemaining]);

  useEffect(() => {
    if (!isActive) return;

    const timer = setInterval(() => {
      setDisplayTime(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isActive, currentSequence]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handleStopSession = async () => {
    if (window.confirm('Are you sure you want to stop the QR session?')) {
      await stopSession(session.session_id);
      onNewSession();
    }
  };

  // Show loading state
  if (loading) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '40px',
        backgroundColor: '#fff',
        borderRadius: '10px',
        border: '1px solid #ddd'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
        <h3>Starting QR Session...</h3>
        <p>Please wait while we generate your QR code.</p>
      </div>
    );
  }

  if (!isActive) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '40px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        border: '1px solid #ddd'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
        <h3>QR Session Ended</h3>
        <p>The attendance session has completed successfully.</p>
        <button
          onClick={onNewSession}
          style={{
            backgroundColor: '#F04915',
            color: 'white',
            padding: '12px 30px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: 'pointer',
            marginTop: '20px'
          }}
        >
          Start New Session
        </button>
      </div>
    );
  }

  return (
    <div style={{
      textAlign: 'center',
      backgroundColor: '#fff',
      padding: '30px',
      borderRadius: '10px',
      border: '2px solid #28a745',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      position: 'relative'
    }}>
      <h2 style={{ color: '#28a745', marginBottom: '20px' }}>
        📱 QR Code Active
      </h2>

      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <p><strong>Module:</strong> {session?.module_code} - {session?.module_name}</p>
        <p><strong>Session:</strong> {session?.session_type}</p>
        <p><strong>Session ID:</strong> {session?.session_id}</p>
      </div>

      {/* QR Code Display */}
      <div style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        border: '1px solid #ddd',
        marginBottom: '20px',
        display: 'inline-block'
      }}>
        {qrCode ? (
          <img 
            src={qrCode} 
            alt="QR Code for Attendance"
            style={{
              maxWidth: '300px',
              width: '100%',
              height: 'auto'
            }}
          />
        ) : (
          <div style={{
            width: '300px',
            height: '300px',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #ddd'
          }}>
            <p>Loading QR Code...</p>
          </div>
        )}
      </div>

      {/* Timer and Sequence Info */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-around',
        marginBottom: '20px',
        backgroundColor: '#e9ecef',
        padding: '15px',
        borderRadius: '8px'
      }}>
        <div>
          <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Time Remaining</p>
          <p style={{ 
            margin: '5px 0 0 0', 
            fontSize: '24px', 
            fontWeight: 'bold',
            color: displayTime <= 30 ? '#dc3545' : '#28a745'
          }}>
            {formatTime(displayTime)}
          </p>
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>QR Sequence</p>
          <p style={{ margin: '5px 0 0 0', fontSize: '24px', fontWeight: 'bold', color: '#007bff' }}>
            {currentSequence} / 18
          </p>
        </div>
      </div>

      {/* Control Buttons */}
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <button
          onClick={handleStopSession}
          style={{
            backgroundColor: '#dc3545',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Stop Session
        </button>
        
        <button
          onClick={onNewSession}
          style={{
            backgroundColor: '#6c757d',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          New Session
        </button>
      </div>
    </div>
  );
};

export default QRDisplay;